import { type AuthenticatedUser } from '@/lib/types';
import dummyFunction from '@/lib/utils/dummyFunction';
import { createContext } from 'react';

const AuthenticationStateContext = createContext<
  [AuthenticatedUser | null, () => void]
>([null, dummyFunction]);

export default AuthenticationStateContext;
